/* eslint-disable react/display-name */
import React, { useState } from 'react'
import NewCopyIcon from '../../../components/icons/newCopy'
import { copyToClipboard } from '../../../utils/copyToClipboard'
import { CheckmarkBackgroundSmIcon } from '@paypalcorp/pp-react'

import './new-code-blocks-wrapper.css'

export default ({ children }: any) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga
  const [isCopied, setIsCopied] = useState(false)

  const handleCopyClipboard = () => {
    copyToClipboard(children.props.children)
    setIsCopied(true)

    setTimeout(() => {
      setIsCopied(false)
    }, 3000)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: 'copy-content',
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: 'copyContent',
      })
    }
  }

  return (
    <div className="new-codeBlocks-wrapper">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginBottom: '22px',
          height: '40px',
        }}
      >
        <div onClick={() => handleCopyClipboard()}>
          {isCopied ? (
            <CheckmarkBackgroundSmIcon
              size="lg"
              className="checkmark-bg-icon"
              color="sysColorAccent3Main"
            />
          ) : (
            <NewCopyIcon />
          )}
        </div>
      </div>
      {children}
    </div>
  )
}
